import { isDefined } from '@sgme/fp';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { WithAdditionalInformation } from 'components/missed-deal-feedback/components/with-additional-information';
import { ActionButtons } from 'components/missed-deal-feedback/ready/action-buttons';
import { ClientTraded } from 'components/missed-deal-feedback/ready/client-traded';
import { Comment } from 'components/missed-deal-feedback/ready/comment';
import { PriceEnhanced } from 'components/missed-deal-feedback/ready/price-enhanced';
import { SgPositioning } from 'components/missed-deal-feedback/ready/sg-positioning';
import { CompetitionParametersTable } from 'components/missed-deal-feedback/ready/table';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormIdProps } from 'shared/props';
import { getIsWithAdditionalInformation } from 'state/missed-deal-feeedback/selectors';

export function MissedDealFeedbackReadyForm({ formId }: FormIdProps) {
  const isWithAdditionalInformation = useAppSelector(s => getIsWithAdditionalInformation(s, formId));

  return (
    <Layout.Wrapper>
      <Layout.Body>
        <WithAdditionalInformation formId={formId} />
        {isWithAdditionalInformation === true && (
          <>
            <CompetitionParametersTable formId={formId} />
            <Layout.Block>
              <SgPositioning formId={formId} />
              <ClientTraded formId={formId} />
              <PriceEnhanced formId={formId} />
            </Layout.Block>
          </>
        )}
        {isDefined(isWithAdditionalInformation) && <Comment formId={formId} />}
      </Layout.Body>

      <ActionButtons formId={formId} />
    </Layout.Wrapper>
  );
}
